import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Share = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M11 6.967V5a1 1 0 0 0-1.707-.707l-3 3-3 3-.774.774.841.701 3 2.5 3 2.5A.998.998 0 0 0 11 16v-2.232c5.028-1.198 9.251 2.897 9.294 2.941L22 18.401V16c0-2.627-.858-4.745-2.551-6.293C16.818 7.3 12.892 6.972 11 6.967z", key: "k0" })));
});
Share.displayName = 'Share';
export var ShareDimensions = { height: 24, width: 24 };
